<template>
  <div class="plan-item-5">
    <div class="plan-padding">
      <div class="title"
        >相关参考案例<!-- <span class="title-desc">与您相似度90%</span> --></div
      >
    </div>
    <div class="case-scroll">
      <div class="case-list">
        <div class="case-item" v-for="(item, index) in caseData" :key="index">
          <img
            class="case-image"
            :src="item.image"
            alt=""
            @click="bindToCase(item)"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    data: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      caseData: [
        {
          id: 1,
          image:
            'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/d626f18d32b7e4b5456366b2b50a9ed1.png'
        },
        {
          id: 2,
          image:
            'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/62351da91cc578ca6f9b9fcae1aec6f1.png'
        },
        {
          id: 3,
          image:
            'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/cc3305afc77a92ab489a3ade0f9dba93.png'
        }
      ]
    }
  },
  created() {},
  methods: {
    bindToCase(item) {
      this.$router.push('/custom-member-card?tab=' + item.id)
    }
  }
}
</script>
<style lang="scss" scoped>
.plan-item-5 {
  .plan-padding {
    padding: 0px 14px;
  }
  .title {
    position: relative;
    color: rgba(48, 48, 56, 0.7);
    padding-left: 10px;
    font-weight: bold;
    font-size: 16px;
    line-height: 22px;
    margin-bottom: 11px;
    .title-desc {
      margin-left: 6px;
      font-size: 12px;
      color: rgba(48, 48, 56, 0.5);
      line-height: 17px;
    }
  }

  .title::after {
    content: '';
    position: absolute;
    left: 0;
    top: 50%;
    width: 4px;
    height: 20px;
    background-color: rgba(48, 48, 56, 0.3);
    transform: translate(0%, -50%);
  }

  .case-scroll {
    width: 100%;
    overflow-x: scroll;
  }

  .case-list {
    padding: 0px 10px;
    display: inline-flex;
    flex-wrap: nowrap;

    .case-item {
      width: 318px;
      height: 284px;
      margin-right: 10px;
      .case-image {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }

    .case-item:last-child {
      margin-right: 0;
    }
  }
}
</style>
